export enum TimeSuperiorPermission {
  ADMINISTRATOR_OF_EVERYTHING = 1,
  ADMINISTRATOR_OF_SELECTED_COMPANY = 2,
  COMPANY_PERSONNEL = 3,
  GROUP_PERSONNEL = 4,
  COMPANY_PREVIEW = 5,
  GROUP_PREVIEW = 6,
}
